import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import { menusAndItemsRequested } from '../../actions/menus'
import TabsCartSidebar from '../../containers/tabs/TabsCartSidebar'
import TabsCartModal from '../../containers/tabs/TabsCartModal'
import Items from '../../containers/tabs/Items'
import Navbar from '../../containers/Navbar'
import CategoryBar from '../../containers/CategoryBar'

import styles from './TabMenu.module.scss'

import { ReactComponent as LoadingIcon } from '../../assets/loading.svg'
import { getIsSuitesMode } from '../../selectors/config'
import { getActiveAttendantId, getAttendants } from '../../selectors/attendant'

const TabMenu = ({ className, menusItemsAreLoading, currentMenuIsLoading, fetchMenusAndItems, isSuitesMode, attendantsExist, hasActiveAttendant, redirectToLogin }) => {
  const classNames = cn(styles.tabMenu, className)

  useEffect(() => {
    if (attendantsExist && !hasActiveAttendant) {
      redirectToLogin()
    }
  }, [hasActiveAttendant])

  useEffect(() => {
    if (localStorage.getItem('accessToken')) fetchMenusAndItems()
  }, [fetchMenusAndItems])

  //temporary until being able to polish later
  const cart = document?.body?.clientWidth <= 800 ? <TabsCartModal /> : <TabsCartSidebar className={styles.sidebar} />

  return (
    <div className={classNames}>
      <Navbar className={styles.navbar} showCustomerHeader={isSuitesMode} tabMenu={document?.body?.clientWidth <= 800}/>
      {cart}
      <div className={styles.content}>
          <CategoryBar className={styles.categories} />
          {menusItemsAreLoading || currentMenuIsLoading ?
              <LoadingIcon className={styles.loadingSpinner} /> :
              <Items className={styles.items} />}
      </div>
    </div>)
}

const mapStateToProps = (state) => {
  
  const attendantsExist = !isEmpty(getAttendants(state))
  const hasActiveAttendant = getActiveAttendantId(state) !== undefined

  return {
    menusItemsAreLoading: state.items.menusItemsAreLoading,
    currentMenuIsLoading: state.items.currentMenuIsLoading,
    isSuitesMode: getIsSuitesMode(state),
    attendantsExist,
    hasActiveAttendant,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const replace = props?.history?.replace ?? (() => {})

  return {
    fetchMenusAndItems: () => {
      dispatch(menusAndItemsRequested())
    },
    redirectToLogin: () => {
      replace('/user-login')
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TabMenu))
